import React from "react";
import styles from "./Footer.module.css";
import Icon from "../../pages/Home/common/Icon";

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerTop}>
        <div className={styles.footerGrid}>
          <div className={styles.footerCol}>
            <span className={styles.eyebrow}>Alliance Automation</span>
            <h3 className={styles.footerHeading}>Office</h3>
            <p className={styles.footerText}>"Passion for automation" has an address.</p>
            <ul className={styles.footerContact}>
              <li><a href="tel:+91-124-4477-951"><Icon.Phone /> +91-124-4477-951</a></li>
              <li><Icon.Pin /> Plot No. 171, Sector 6, IMT – Manesar Gurugram – 122050, INDIA</li>
              <li><Icon.Globe /> www.allianceautomation.in</li>
              <li><a href="mailto:pradeep@allianceautomation.in"><Icon.Mail /> pradeep@allianceautomation.in</a></li>
            </ul>
          </div>

          <div className={styles.footerCol}>
            <span className={styles.eyebrow}>locations</span>
            <h3 className={styles.footerHeading}>
              <span className={styles.footerHeadingAccentWhite}>in </span>Gurugram
            </h3>
          </div>

          <div className={styles.footerCol}>
            <span className={styles.eyebrow}>get in touch</span>
            <h3 className={styles.footerHeading}>Follow us</h3>
            <p className={styles.footerText}>To keep ahead we have lots of updates about the company and the Automation world in general when you follow us on these platforms.</p>
             <div className={styles.footerSocial}>
               <a href="https://www.facebook.com/allianceautomationindia/" aria-label="Facebook" className={styles.footerSocialIcon} target="_blank" rel="noopener noreferrer"><Icon.Facebook /></a>
               <a href="https://www.linkedin.com/in/alliance-automation-2bb24053" aria-label="LinkedIn" className={styles.footerSocialIcon} target="_blank" rel="noopener noreferrer"><Icon.LinkedIn /></a>
               <a href="https://www.youtube.com/channel/UC-0RZR5y9seI-2qjIocyYCw?themeRefresh=1" aria-label="YouTube" className={styles.footerSocialIcon} target="_blank" rel="noopener noreferrer"><Icon.YouTube /></a>
             </div>
          </div>
        </div>
      </div>

      <div className={styles.footerBottomWrap}>
        <div className={styles.footerDivider} />
        <div className={styles.footerBottom}>
          <p>
            Copyright {new Date().getFullYear()} © Alliance Automation
            <span className={styles.footerBottomDivider}>|</span>
            Transformation Partner{" "}
            <a
              href="https://digiko.in"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.footerBottomLink}
            >
              DIGIKO.IN
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}